export function setProducts (state, products) {
  state.products = products
}

export function addProducts (state, products) {
  state.products.products.push(...products.products)
  state.products.self = products.self
  state.products.next = products.next
}

export function setProduct (state, product) {
  state._product = product
}

export function setSearchConfig (state, searchConfig) {
  state.searchConfig = searchConfig
}

export function setVariant (state, variant) {
  state.selectedVariant = variant
}

export function setHomeProducts (state, products) {
  state.homeProducts = products
}
